package com.essntl.core.stripe.data.response

import com.essntl.core.stripe.domain.models.PaymentLink
import kotlinx.serialization.Serializable

@Serializable
internal data class PaymentLinkDto(
    val id: String,
    val url: String,
    val active: Boolean,
) {
    fun toModel() =
        PaymentLink(
            id = id,
            url = url,
            active = active,
        )
}
